// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__Wz1us","link":"styles_link__gEM0z","table":"styles_table__ZbrGr"};